import {
    CssBaseline,
    StyledEngineProvider,
    ThemeProvider,
} from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import React from "react";
import AppTheme from "Theme/AppTheme";
import AuthPage from "./AuthPage";

function SessionExpiredUser() {
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={AppTheme}>
                <CssBaseline />
                <AuthPage title="Session Expired">
                    <AcxButton
                        fullWidth
                        component={"a"}
                        href="/app"
                        color="primary"
                        sx={{
                            height: "36px",
                            mt: 1.5,
                        }}
                    >
                        Back to login
                    </AcxButton>
                </AuthPage>
            </ThemeProvider>
        </StyledEngineProvider>
    );
}

export default SessionExpiredUser;
